import React from "react"
// import PropTypes from "prop-types"
const SegmentMain = ({ children }) => <div>{children}</div>

export default SegmentMain

//before :
//const SegmentMain = ({ children }) => <Col id="SegmentMain">{children}</Col>



// WEBPACK FOOTER //
// ./src/large/SegmentMain.js